<template>
    <v-app>
      <v-app-bar app clipped-left dense dark color="blue darken" v-if="isAppBar" :class="'.main_menu__navigation_drawer'">
        <v-app-bar-nav-icon v-if="isLoggedIn" @click.stop="drawer = !drawer"/>

        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer/>

        <v-btn icon :to="'/login'" v-if="!isLoggedIn">
          <v-icon>mdi-account-circle</v-icon>
        </v-btn>
        <v-menu
          bottom
          left          
        >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon            
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item>
            <v-btn block left text color="primary" dark @click="onApi">API</v-btn>
          </v-list-item>
          <v-list-item v-if="!isLoggedIn">
            <v-btn block text color="primary" dark :to="'/login'">Вход</v-btn>
          </v-list-item>
          <v-list-item v-if="isLoggedIn">
            <v-btn block text color="primary" dark @click="onLogout">Выход</v-btn>
          </v-list-item>
        </v-list>
      </v-menu>
      </v-app-bar>

      <v-navigation-drawer v-if="isLoggedIn && isAppBar"
          v-model="drawer"
          :clipped="$vuetify.breakpoint.lgAndUp"
          app
          width="275"        
        >
        <v-list dense>
          <v-list-group
            v-for="item in links"
            :key="item.title"
            v-model="item.active"
            :prepend-icon="item.action"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="subItem in item.items"
              :key="subItem.title"
              link
              :to="subItem.link"   
              v-model="subItem.active"           
            >
              <v-list-item-content>
                <v-list-item-title v-text="subItem.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-navigation-drawer>

      <v-content>
        <transition>
          <keep-alive v-if="isLoggedIn">
            <router-view ref="cRoute"></router-view>
          </keep-alive>
          <router-view v-else></router-view>
        </transition>
      </v-content>
      <v-snackbar-queue :items="messages" top right @remove="removeItem"></v-snackbar-queue>
      <v-overlay :value="loading" style="z-index: 99998" >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
  </v-app>
</template>
<script>

import { MENU_ADMIN_LINKS, MENU_USER_LINKS, MENU_RADAR_LINKS} from './models/menu'

export default {
  name: 'App',
  data() {
    return {
      componentKey: 0,
      expand: true,
      routesWithoutAppBar: ['HOME', 'LOGIN', 'API_SERVICES'],
      to: '',
      color: 'info',
      mode: '',       
      timeout: 2000,
      x: null,
      y: 'top',
      drawer: true,
      mini: true,
      accountLoggedLinks: [
        { title: 'Logout', icon: 'exit_to_app', url: '/logout' },
      ],
      accountNotLoggedLinks: [
        { title: 'Login', icon: 'account_box', url: '/login' },        
      ],
      adminLinks: MENU_ADMIN_LINKS,
      userLinks: MENU_USER_LINKS,
      radarsLinks: MENU_RADAR_LINKS
    }
  },
  async created() {    
    const check = await this.$store.getters.CHECK;
    if (!check) {
      await this.$store.dispatch('LOGOUT');
      this.$router.push({name: 'HOME'});
    }
  },
  computed: {
    isAppBar() {
      if (this.routesWithoutAppBar.includes(this.routeName)) {
        return false;
      } 
      return true;
    },
    loading() {
      return this.$store.getters.LOADING;
    },
    forceLoading() {
      const loading = this.loading;
      this.$forceUpdate();
      return loading;
    },
    error() {
      return this.$store.getters.ERROR;
    },
    text() {
      return this.$store.getters.ERROR;
    },
    snackbar() {
       return !!(this.$store.getters.ERROR)
    },
    messages() {
       return this.$store.getters.MESSAGES;
    }, 
    isLoggedIn() {
       return this.$store.getters.IS_LOGGED_IN;
    }, 
    isRadarContract() {
      return this.$store.getters.IS_RADAR_CONTRACT;
    },
    isContract() {
      return this.$store.getters.IS_CONTRACT;
    },
    links() {
      if (!this.$store.getters.IS_LOGGED_IN) return [];
      if (this.$store.getters.IS_ADMIN) return this.adminLinks;
      if (this.$store.getters.IS_AUTH_USER) {
        let links = [];

        if (this.isContract) {
          links = links.concat(this.userLinks);
        }

        if (this.isRadarContract) {
          links = links.concat(this.radarsLinks);
        }
        
        return links;
      }
      if (!this.$store.getters.IS_AUTH_USER) return this.adminLinks;
      return [];
    },   
    title() {
      const mainTile = 'WAPI'
      if (this.$store.getters.TITLE) {
        return `${mainTile} | ${this.$store.getters.TITLE}`;
      }

      return mainTile;
    },
    routeName() {
      const active = this.links.find(x => x.items.some(z => z.link === this.$route.fullPath));
      if (active) {
        active.active = true;
      }

      return this.$route.name;
    },
    routeFullPath() {
      return this.$route.fullPath;
    },
  },
  watch: {
    loading() {
      this.$forceUpdate();
    }
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
    onCloseSnackbar() {
      this.$store.dispatch('CLEAR_ERROR');
    },
    removeItem(id) {
      this.$store.dispatch('DELETE_MESSAGE', id);
    },
    onLogout() {
      this.$store.dispatch('LOGOUT');
      this.$router.push({name: 'LOGIN'});
    },
    onApi() {          
      this.$router.push({name: 'API_SERVICES'});
    }
  },  
};
</script>

<style>
.main_menu__navigation_drawer {
  z-index: 999 !important;
}
.wapi_dialog__dialog {
  z-index: 999999 !important;
}
.wapi_map__map {
  z-index: 4 !important;
}
.basetime_container {
  display: flex;
  align-items: center;
}
.basetime_minute {  
    font-size: 7pt;
    vertical-align: top;
    line-height: 20px;
}
</style>